import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialFinanceByTrialId: ITrialFinanceLoadByTrialIdActionCreator = (trialId) => {
        return {
            type: ACTION_TRIALFINANCE_LOAD_BY_TRIAL_ID,
            trialId
        }
    },
    LoadTrialFinanceById: ITrialFinanceLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALFINANCE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialFinanceLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALFINANCE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialFinanceLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALFINANCE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialFinance: ITrialFinanceSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALFINANCE_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialFinanceSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALFINANCE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialFinanceSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALFINANCE_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialFinance: ITrialFinanceValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALFINANCE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialFinanceValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALFINANCE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialFinanceValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALFINANCE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialFinance: ITrialFinanceCreateActionCreator = (trialId) => {

        return {
            type: ACTION_TRIALFINANCE_CREATE,
            trialId
        }
    },
    CreateSuccess: ITrialFinanceCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALFINANCE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialFinanceCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALFINANCE_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncTrialFinance: ITrialFinanceSyncActionCreator = (trialId) => {

        return {
            type: ACTION_TRIALFINANCE_SYNC,
            trialId
        }
    },
    SyncSuccess: ITrialFinanceSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALFINANCE_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: ITrialFinanceSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALFINANCE_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialFinanceClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALFINANCE_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialFinanceFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALFINANCE_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALFINANCE_LOAD_BY_TRIAL_ID = "ACTION_TRIALFINANCE_LOAD_BY_TRIAL_ID",
    ACTION_TRIALFINANCE_LOAD_BY_ID = "ACTION_TRIALFINANCE_LOAD_BY_ID",
    ACTION_TRIALFINANCE_LOAD_SUCCESS = "ACTION_TRIALFINANCE_LOAD_SUCCESS",
    ACTION_TRIALFINANCE_LOAD_FAILURE = "ACTION_TRIALFINANCE_LOAD_FAILURE",

    ACTION_TRIALFINANCE_SAVE = "ACTION_TRIALFINANCE_SAVE",
    ACTION_TRIALFINANCE_SAVE_SUCCESS = "ACTION_TRIALFINANCE_SAVE_SUCCESS",
    ACTION_TRIALFINANCE_SAVE_FAILURE = "ACTION_TRIALFINANCE_SAVE_FAILURE",

    ACTION_TRIALFINANCE_VALIDATE = "ACTION_TRIALFINANCE_VALIDATE",
    ACTION_TRIALFINANCE_VALIDATE_SUCCESS = "ACTION_TRIALFINANCE_VALIDATE_SUCCESS",
    ACTION_TRIALFINANCE_VALIDATE_FAILURE = "ACTION_TRIALFINANCE_VALIDATE_FAILURE",

    ACTION_TRIALFINANCE_CREATE = "ACTION_TRIALFINANCE_CREATE",
    ACTION_TRIALFINANCE_CREATE_SUCCESS = "ACTION_TRIALFINANCE_CREATE_SUCCESS",
    ACTION_TRIALFINANCE_CREATE_FAILURE = "ACTION_TRIALFINANCE_CREATE_FAILURE",

    ACTION_TRIALFINANCE_SYNC = "ACTION_TRIALFINANCE_SYNC",
    ACTION_TRIALFINANCE_SYNC_SUCCESS = "ACTION_TRIALFINANCE_SYNC_SUCCESS",
    ACTION_TRIALFINANCE_SYNC_FAILURE = "ACTION_TRIALFINANCE_SYNC_FAILURE",

    ACTION_TRIALFINANCE_CLEAR = "ACTION_TRIALFINANCE_CLEAR",

    ACTION_TRIALFINANCE_FILTER = "ACTION_TRIALFINANCE_FILTER";

export interface ITrialFinanceLoadByTrialIdAction {
    type: "ACTION_TRIALFINANCE_LOAD_BY_TRIAL_ID";
    trialId: number;
}

export interface ITrialFinanceLoadByTrialIdActionCreator {
    (trialId: number): ITrialFinanceLoadByTrialIdAction;
}

export interface ITrialFinanceLoadSuccessAction {
    type: "ACTION_TRIALFINANCE_LOAD_SUCCESS";
    formData: Dtos.TrialFinance | Dtos.TrialFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialFinanceLoadSuccessActionCreator {
    (
        formData: Dtos.TrialFinance | Dtos.TrialFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialFinanceLoadSuccessAction;
}

export interface ITrialFinanceLoadFailureAction {
    type: "ACTION_TRIALFINANCE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialFinanceLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialFinanceLoadFailureAction;
}

export interface ITrialFinanceLoadByIdAction {
    type: "ACTION_TRIALFINANCE_LOAD_BY_ID";
    id: number;
}

export interface ITrialFinanceLoadByIdActionCreator {
    (id: number): ITrialFinanceLoadByIdAction;
}

export interface ITrialFinanceSaveAction {
    type: "ACTION_TRIALFINANCE_SAVE";
    formData: Dtos.TrialFinance;

}

export interface ITrialFinanceSaveActionCreator {
    (
        formData: Dtos.TrialFinance
    ): ITrialFinanceSaveAction;
}

export interface ITrialFinanceSaveSuccessAction {
    type: "ACTION_TRIALFINANCE_SAVE_SUCCESS";
    formData: Dtos.TrialFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialFinanceSaveSuccessActionCreator {
    (
        formData: Dtos.TrialFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialFinanceSaveSuccessAction;
}

export interface ITrialFinanceSaveFailureAction {
    type: "ACTION_TRIALFINANCE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialFinanceSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialFinanceSaveFailureAction;
}

export interface ITrialFinanceValidateAction {
    type: "ACTION_TRIALFINANCE_VALIDATE";
    formData: Dtos.TrialFinance;

}

export interface ITrialFinanceValidateActionCreator {
    (
        formData: Dtos.TrialFinance
    ): ITrialFinanceValidateAction;
}

export interface ITrialFinanceValidateSuccessAction {
    type: "ACTION_TRIALFINANCE_VALIDATE_SUCCESS";
    formData: Dtos.TrialFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialFinanceValidateSuccessActionCreator {
    (
        formData: Dtos.TrialFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialFinanceValidateSuccessAction;
}

export interface ITrialFinanceValidateFailureAction {
    type: "ACTION_TRIALFINANCE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialFinanceValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialFinanceValidateFailureAction;
}

export interface ITrialFinanceCreateAction {
    type: "ACTION_TRIALFINANCE_CREATE",
    trialId: number
}

export interface ITrialFinanceCreateActionCreator {
    (trialId: number): ITrialFinanceCreateAction
}

export interface ITrialFinanceCreateSuccessAction {
    type: "ACTION_TRIALFINANCE_CREATE_SUCCESS";
    formData: Dtos.TrialFinance;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialFinanceCreateSuccessActionCreator {
    (
        formData: Dtos.TrialFinance,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialFinanceCreateSuccessAction;
}

export interface ITrialFinanceCreateFailureAction {
    type: "ACTION_TRIALFINANCE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialFinanceCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialFinanceCreateFailureAction;
}

export interface ITrialFinanceClearAction {
    type: "ACTION_TRIALFINANCE_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialFinanceClearActionCreator {
    (propertiesToClear?: string[]): ITrialFinanceClearAction;
}

export interface ITrialFinanceFilterActionCreator {
    (formFilter: IFormFilter): ITrialFinanceFilterAction;
}

export interface ITrialFinanceFilterAction {
    type: "ACTION_TRIALFINANCE_FILTER";
    formFilter: IFormFilter;
}

export interface ITrialFinanceSyncAction {
    type: "ACTION_TRIALFINANCE_SYNC",
    trialId: number
}

export interface ITrialFinanceSyncActionCreator {
    (trialId: number): ITrialFinanceSyncAction
}

export interface ITrialFinanceSyncSuccessAction {
    type: "ACTION_TRIALFINANCE_SYNC_SUCCESS";
    formData: Dtos.TrialFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialFinanceSyncSuccessActionCreator {
    (
        formData: Dtos.TrialFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialFinanceSyncSuccessAction;
}

export interface ITrialFinanceSyncFailureAction {
    type: "ACTION_TRIALFINANCE_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialFinanceSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialFinanceSyncFailureAction;
}

export type TrialFinanceAction =
    ITrialFinanceLoadByTrialIdAction |
    ITrialFinanceLoadByIdAction |
    ITrialFinanceLoadFailureAction |
    ITrialFinanceLoadSuccessAction |
    ITrialFinanceSaveAction |
    ITrialFinanceSaveSuccessAction |
    ITrialFinanceSaveFailureAction |
    ITrialFinanceValidateAction |
    ITrialFinanceValidateSuccessAction |
    ITrialFinanceValidateFailureAction |
    ITrialFinanceCreateAction |
    ITrialFinanceCreateSuccessAction |
    ITrialFinanceCreateFailureAction |
    ITrialFinanceSyncAction |
    ITrialFinanceSyncSuccessAction |
    ITrialFinanceSyncFailureAction |
    ITrialFinanceClearAction | 
    ITrialFinanceFilterAction;
